import { AgendaPage } from '@/components/agenda/AgendaPage';
import { useFeatureTracking } from '@/hooks/useFeatureTracking';

export default function Agenda() {
  useFeatureTracking('agenda');
  return <AgendaPage />;
}
